import memoize from 'lodash/memoize';

export const removeFavicon = () => {
  const head = document.getElementsByTagName('head')[0];
  const link = document.querySelector('link[rel="shortcut icon"]');

  if (head && link) {
    head.removeChild(link);
  }
};

// Chrome allows you to simply tweak the HREF of the LINK tag.
// Firefox appears to require that you remove it and re-add it.
export const setFavicon = memoize((url) => {
  removeFavicon();
  const head = document.getElementsByTagName('head')[0];
  const link = document.createElement('link');
  link.rel = 'shortcut icon';
  link.href = url;
  head.appendChild(link);
});

export const setTitle = memoize((title) => {
  document.title = title;
});
